import React, {useState} from 'react';
import {Checkbox} from "@mui/material";
import HeaderService from "../../../../../../API/orders/orders/organization/HeaderService";

const CellCheckboxMHTUnable = ({cell, id, change, setChange, handleModalAlert}) => {

    const [status, setStatus] = useState(cell.getValue);

    const handle = () => {
        HeaderService.unable(id, !status)
            .then(function () {
                setStatus(!status)
                setChange(!change)
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    return (
        <div>
            <Checkbox onChange={handle}
                      checked={status}
                      sx={{'& .MuiSvgIcon-root': {fontSize: 20}}}
            />
        </div>
    );
};

export default CellCheckboxMHTUnable;